import cx from 'classnames'
import TemplateStyles from '../ReviewsWizard/ReviewTemplates/ReviewTemplates.module.scss'
import { ReviewTemplatesModalProps } from './types'
import { collectResults } from 'utils/query'
import { ReviewTemplateRow } from 'components/ReviewsWizard/ReviewTemplates/ReviewTemplateRow'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { useReviewTemplates } from 'hooks/queries/reviewTemplates/useReviewTemplates'
import { ReviewTemplatesSkeleton } from 'components/ReviewsWizard/ReviewTemplates/ReviewTemplatesSkeleton'
import { Modal } from 'almanac-ui/Modal'
import { ColdState } from 'components/ReviewsWizard/ReviewTemplates/ColdState'

export const ReviewTemplatesModalContent = ({ workspaceId, onBack, onSelect }: ReviewTemplatesModalProps) => {
  const queryResult = useReviewTemplates({ workspaceId })
  const templates = collectResults(queryResult, (data) => data.review_templates)
  const renderContent = () => {
    if (queryResult.isLoading) return <ReviewTemplatesSkeleton />
    if (templates.length === 0) return <ColdState />

    return (
      <>
        <div className={cx(TemplateStyles.headers, TemplateStyles.withLastEditor)}>
          <div>Template name</div>
          <div>Last edited by</div>
          <div>Used</div>
        </div>
        {templates.map((template) => (
          <ReviewTemplateRow key={template.id} template={template} onSelect={onSelect} showLastEditor />
        ))}
      </>
    )
  }

  return (
    <>
      {onBack && (
        <Modal.Top>
          <Modal.BackButton onPress={onBack} />
        </Modal.Top>
      )}
      <Modal.Header title="Review Templates" />
      <Modal.Content>
        <div className={TemplateStyles.container}>
          {renderContent()}
          <InfiniteScroll hasMore={queryResult.hasNextPage ?? false} loadMore={queryResult.fetchNextPage} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent />
      </Modal.Footer>
    </>
  )
}
